import { AxiosPromise } from 'axios';
import { http } from 'services';

import * as Types from './types';

export const List = (): AxiosPromise<{ categories: Types.IApi.Category.Response[] }> => {
  return http.request.get<{ categories: Types.IApi.Category.Response[] }>(`/reference/documents/categories`);
};
